module.exports = __webpack_public_path__ + "img/10.6eff4f98.png";